module.exports = "/images/vendor/flag-icon-css/flags/1x1/jm.svg?b7b13124a4068892dc2452d744a42cc1";